
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gioi-thieu",
      function () {
        return require("private-next-pages/gioi-thieu/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gioi-thieu"])
      });
    }
  